import './SettingsPage.css'





const SettingsPage = () => {
    return (
        <div>SettingsPage</div>
    )
}

export default SettingsPage